import { Box, BoxProps, Typography } from '@mui/material';
import { LoaderStyles } from './styles';

type Props = BoxProps & {
  value?: number;
};

export const Loader = (props: Props) => {
  const { color = '#fff' } = props;
  return (
    <Box {...props} width="80px" height="80px">
      {/* Can be 0 (zero) sometimes */}
      {props.value !== undefined && (
        <Typography
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '20px',
            color,
            '&>span': {
              fontSize: '15px',
              ml: '1px',
            },
          }}
        >
          {props.value}
          <span>%</span>
        </Typography>
      )}
      <LoaderStyles color={color as string}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </LoaderStyles>
    </Box>
  );
};
